import { MIME_TYPE_TO_FILE_TYPE_MAP } from '../constants/mimeTypeToFileTypeMap'
import { MimeType } from '../enums'

export const isValidMimeType = (mimeType: string): mimeType is MimeType => {
  return mimeType in MIME_TYPE_TO_FILE_TYPE_MAP
}
